module.exports = __webpack_public_path__ + "img/avatar2.9ddbe962.png";